export function resolveReusableResumeId(
  hasExistingResume: boolean,
  existingResumeId: string | null | undefined,
): string | undefined {
  if (!hasExistingResume) return undefined;
  const trimmed = existingResumeId?.trim();
  return trimmed || undefined;
}

